<template>
  <div class="container mx-auto" :class="(dark) ? 'dark' : 'light'">
    <div class="flex flex-col lg:flex-row flex-wrap min-h-screen m-4 lg:mt-16 lg:mx-16">
      <div class="flex justify-center content-center block lg:hidden">
          <button class="text-center block py-2 px-4 rounded-lg cursor-pointer focus:outline-none"
            :class="[(showN && !dark) ? 'bg-dpurpleLight text-white' : '', (dark  && showN) ? 'text-white bg-widgetheaderDark' : '', (dark  && !showN) ? 'text-white' : '']"
            @click="changeStatN()"
          >{{ $t('news.newsbtns') }}</button>
          <button
            class="text-center block py-2 px-4 rounded-lg cursor-pointer focus:outline-none"
            :class="[(showT) ? 'bg-twitter text-white' : '', (dark) ? 'text-white' : '']"
            @click="changeStatT()"
          >{{ $t('news.twitterbtn') }}</button>
      </div>
      <div class="w-full lg:w-1/2" v-if="showN">
        <div class="timeline relative" :class="$i18n.locale == 'ar' ? 'tm-right' : 'tm-left'">
          <div :class="$i18n.locale == 'ar' ? 'tmdt-right' : 'tmdt-left'" class="timeline-data relative px-4 py-2 lg:py-4 lg:px-12 m-0 lg:m-4 widget rounded-lg" v-for="(item, i) in mapnews" :key="'map' + i">
            <div class="widget_title text-white p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark' : 'bg-dpurpleLight'">
              <h2 class="text-xl">{{ $t('news.newstitle') }}</h2>
            </div>
            <div class="widget-content rounded-b-lg px-8 py-4 overflow-auto shad" :class="(dark) ? 'bg-widgetbgDark text-white' : 'bg-white'">
              <span class="block mb-4" v-text="($i18n.locale == 'ar') ? item.title : item.output.title"></span>
              <a :class="(dark) ? 'bg-darkredDark hover:bg-medredDark' : 'bg-dpurpleLight hover:bg-sideLight'" class="inline-block py-2 px-6 transition shadow text-white rounded float-left" target="_blank" :href="($i18n.locale == 'ar') ? 'http://mapanticorona.map.ma' + item.url : 'http://mapanticorona.map.ma' + item.output.link">{{ $t('news.morebtn') }}</a>
            </div>
          </div>
          <div :class="$i18n.locale == 'ar' ? 'tmdt-right' : 'tmdt-left'" class="timeline-data relative px-4 py-2 lg:py-4 lg:px-12 m-0 lg:m-4 widget rounded-lg" v-for="(item, i) in news2m" :key="'2m' + i">
            <div class="widget_title text-white p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark' : 'bg-dpurpleLight'">
              <h2 class="text-xl">{{ $t('news.newstitle') }}</h2>
            </div>
            <div class="widget-content rounded-b-lg px-8 py-4 overflow-auto shad" :class="(dark) ? 'bg-widgetbgDark text-white' : 'bg-white'">
              <span class="block mb-4">{{item.title}}</span>
              <a :class="(dark) ? 'bg-darkredDark hover:bg-medredDark' : 'bg-dpurpleLight hover:bg-sideLight'" class="inline-block py-2 px-6 transition shadow text-white rounded float-left" target="_blank" :href="'https://2m.ma' + item.url">{{ $t('news.morebtn') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-1/2" v-if="showT">
        <div class="timeline tweeters relative" :class="$i18n.locale == 'ar' ? 'tm-right' : 'tm-left'">
          <div :class="$i18n.locale == 'ar' ? 'tmdt-right' : 'tmdt-left'" class="tweeters-data timeline-data relative px-4 py-2 lg:py-4 lg:px-12 m-0 lg:m-4 widget rounded-lg" v-for="(item, i) in tweets" :key="i">
            <div class="widget_title bg-twitter text-white p-4 rounded-t-lg">
              <h2 class="text-xl">{{ $t('news.twittertitle') }}</h2>
            </div>
            <div class="widget-content rounded-b-lg bg-white overflow-auto shad">
              <Timeline :id="item.title" sourceType="profile" :options="{tweetLimit: tweetsNumber, chrome: 'noheader nofooter'}"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Timeline } from 'vue-tweet-embed'

export default {
  name:"News",
  computed: {
    dark () {
      return this.$store.state.dark
    }
  },
  data() {
    return {
      showN: true,
      showT: true,
      news: [],
      mapnews: [],
      news2m: [],
      tweets: [
        { title: 'Ministere_Sante' },
        { title: 'ChefGov_ma' },
        { title: 'MAP_Information' },
        { title: 'WHOEMRO' },
        { title: 'DGSN_MAROC' },
        { title: '2MInteractive' },
      ],
      tweetsNumber: 1
    }
  },
  components: {
    Timeline
  },
  methods: {
    getMapNews() {
      let url = (this.$i18n.locale == 'ar') ? 'https://wrapapi.com/use/nabz/covidma/mapexp/latest?wrapAPIKey=dKoPpqXGt2RsaS1rSJHGxRpBmcZbwEhY' : 'https://wrapapi.com/use/nabz/covidma/mapfr/0.0.1?wrapAPIKey=dKoPpqXGt2RsaS1rSJHGxRpBmcZbwEhY'
      axios({ method: 'GET', url: url})
      .then(resp => {
        console.log('MAP : ', resp)
        this.mapnews = (this.$i18n.locale == 'ar') ? resp.data.data.html : resp.data.data.collection
      })
      .catch(err => {
        console.log(err)
      })
    },
    get2mNews() {
      let url = (this.$i18n.locale == 'ar') ? 'https://wrapapi.com/use/nabz/covidma/2m/0.0.1?wrapAPIKey=dKoPpqXGt2RsaS1rSJHGxRpBmcZbwEhY' : 'https://wrapapi.com/use/nabz/covidma/2mfr/0.0.1?wrapAPIKey=dKoPpqXGt2RsaS1rSJHGxRpBmcZbwEhY'
      axios({ method: 'GET', url: url})
      .then(resp => {
        console.log('2M : ', resp);
        this.news2m = (this.$i18n.locale == 'ar') ? resp.data.data.collection : resp.data.data.articles
      })
      .catch(err => {
        console.log(err)
      })
    },    
    checkMobile() {
      if (window.innerWidth < 768) {
        this.showT = false
      }
    },
    changeStatN() {
        this.showN = true
        this.showT = false
    },
    changeStatT() {
        this.showT = true
        this.showN = false
    }
  },
  created() {
    this.getMapNews()
    this.get2mNews()
    this.checkMobile()
  },
  mounted() {
    this.tweetsNumber = (this.$i18n.locale == 'ar') ? 3 : 1
  }
}
</script>

<style lang='scss' scoped>
  .timeline {
    &.tm-left {
      &::after { left: 0 }
    }
    &.tm-right {
      &::after { right: 0 }
    }
    &::after { content: ''; position: absolute; width: 6px; background-color: #3E2D4A; top: 80px; bottom: 0; margin-right: -3px;
    }
    &-data {position: relative; background-color: inherit;
      &.tmdt-left {
        &::after { left: -35px }
      }
      &.tmdt-right {
        &::after { right: -36px }
      }
      &::after { content: url(../assets/icons/info.svg); text-align: center; font-size: 18px; line-height: 40px; color: #fff; position: absolute; width: 40px; height: 40px; background-color: #3E2D4A; top: 56px; border-radius: 50%; z-index: 1; }
    }
  }
  .dark .timeline {
    &::after { background-color: #66153E;
    }
    &-data {
      &::after { background-color: #66153E;}
    }
  }
  .tweeters , .dark .tweeters {
    &::after { background-color: #00acee;
    }
    &-data {
      &::after { content: url(../assets/icons/twitter.svg); background-color: #00acee; line-height: 65px; }
    }
  }
  @media (max-width: 768px) {
    .timeline { 
      &::after { content: ''; display: none; }
      &-data { 
        &::after { content: ''; display: none; }
      }
    }
  }
</style>